import { createContext, useContext } from 'react';

interface IPerformanceReportBuilderPageContext {
  error: unknown;
  isLoading: boolean;
  reloadLayout: () => void;
}

export const PerformanceReportBuilderPageContext =
  createContext<IPerformanceReportBuilderPageContext | null>(null);

export const usePerformanceReportBuilderPageContext = () => {
  const context = useContext(PerformanceReportBuilderPageContext);
  if (!context) throw new Error('usePerformanceBuilderPageContext should be inside of a provider');
  return context;
};
